export default class ErrorHandler {
    public static error(message: any): void
    {
        let $errorContainer = $('.js-error-container');
        $errorContainer.show().text(message);
        scroll(0, 0);
        setTimeout(function () {
            $errorContainer.hide().empty();
        }, 10000);
    }
    public static warning(message: any): void
    {
        console.log && console.log(message);
    }
    public static info(message: any): void
    {
        console.log && console.log(message);
    }
}
